export default __webpack_public_path__ + "static/media/BASIC.a54ad346.png";